export default __webpack_public_path__ + "static/media/5.32838e50.png";